module.exports = __webpack_public_path__ + "static/Ogre-1901d580b2d6ade50d235ca16eca1ba0.jpg";